<script>
import i18n from '@plugins/i18n';

import { Collection, UserCollection } from '@/models';

import Search from './Search.vue';

export default {
    name: 'User',
    extends: Search,
    props: {
        label: {
            type: String,
            default: i18n.t('user')
        },
        collection: {
            type: Collection,
            default: () => new UserCollection()
        },
        itemKey: {
            type: String,
            default: 'id'
        },
        itemText: {
            type: String,
            default: 'name'
        },
        itemDescription: {
            type: String,
            default: 'email'
        },
        testId: {
            type: [String, Object],
            default: 'user_selector'
        }
    },
    data: () => ({
        createForm: () => import('@/components/forms/CreateUser.vue')
    })
};
</script>
